import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
// Icons
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// Internal
import FilterChild from "./FilterChild";
import SelectorChild from "./SelectorChild";
import { filterSpace } from "./helpers";
import { handleTrack, replaceQueryParams } from "../historyUtil";
import MobileFilterbar from "./Mobile";
// startOpen is an optional boolean that determines whether or not the expansion panel is open on first render
// title is an optional string, defaults to "filters"
export default (function (_a) {
    var startOpen = _a.startOpen, title = _a.title, filterList = _a.filterList, toggleFilterOpen = _a.toggleFilterOpen, onApply = _a.onApply, clearMobileParams = _a.clearMobileParams, resetURL = _a.resetURL;
    // gives a warning about switching between controlled/uncontrolled component if startOpen is not explicitly false
    // don't want it to be required and can't reassign prop
    var openEval = !!startOpen;
    var _b = useState(openEval), open = _b[0], setOpen = _b[1];
    useEffect(function () {
        setOpen(openEval);
    }, [openEval]);
    var openFullFilters = function () {
        toggleFilterOpen();
        setOpen(!open);
    };
    var breakpoints = useTheme().breakpoints;
    var isDownMd = useMediaQuery(breakpoints.down("md"));
    if (isDownMd) {
        // This removes empty objects from the list (they are used for extra spaces in desktop view)
        var fullList = filterList.filter(function (item) { return item !== filterSpace; });
        return (React.createElement(MobileFilterbar, { filterList: fullList, openFullFilters: openFullFilters, isOpen: open, title: title || "Filters", onApply: onApply, clearMobileParams: clearMobileParams }));
    }
    var ExpandIcon = function () { return (React.createElement(IconButton, { onClick: openFullFilters, "aria-label": "expandIcon", size: "small" }, open ? (React.createElement(ExpandLessIcon, { "aria-label": "expandLessIcon" })) : (React.createElement(ExpandMoreIcon, { "aria-label": "expandMoreIcon" })))); };
    var history = useHistory();
    var onClear = function () {
        handleTrack(history.location.pathname, "clear");
        replaceQueryParams(history, {}, resetURL);
    };
    return (React.createElement("div", null,
        React.createElement(Box, { display: "flex", justifyContent: "space-between", paddingX: 3 },
            React.createElement(Box, { display: "flex", alignItems: "center" },
                React.createElement(ExpandIcon, null),
                React.createElement(Typography, { variant: "h4" }, title || "Filters")),
            React.createElement(Button, { variant: "text", color: "primary", onClick: onClear }, "Reset")),
        React.createElement(Divider, { variant: "middle" }),
        React.createElement(Collapse, { in: open, timeout: "auto", unmountOnExit: true },
            React.createElement(Box, { display: "flex", paddingTop: 1 },
                React.createElement(FilterChild, { filterList: filterList }),
                React.createElement(SelectorChild, { filterList: filterList })))));
});
//# sourceMappingURL=index.js.map